const ACCESS_TOKEN_KEY = 'auth_access_token';
const REFRESH_TOKEN_KEY = 'auth_refresh_token';

// Token cookies are re-written on every refresh, so this window slides forward
// each time the user is active. It must be >= the backend refresh-token TTL
// (REFERESH_SESSION_TIMEOUT) so the browser never drops a still-valid refresh
// token — otherwise the user would be logged out even though the token is live.
function setCookie(name: string, value: string, days = 30) {
  if (typeof window === 'undefined') return;
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
}

function getCookie(name: string) {
  if (typeof window === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name: string) {
  if (typeof window === 'undefined') return;
  document.cookie = name + '=; Max-Age=-99999999; path=/; SameSite=Lax';
}

let accessToken: string | null = null;
let refreshToken: string | null = null;

export function getAccessToken(): string | null {
  if (!accessToken && typeof window !== 'undefined') {
    accessToken = getCookie(ACCESS_TOKEN_KEY);
  }
  return accessToken;
}

export function getRefreshToken(): string | null {
  if (!refreshToken && typeof window !== 'undefined') {
    refreshToken = getCookie(REFRESH_TOKEN_KEY);
  }
  return refreshToken;
}

/** Get persisted token for refresh on load (from cookies) */
export function getPersistedTokenForRefresh(): string | null {
  return getRefreshToken();
}

export function setAuthTokens(tokens: { accessToken: string; refreshToken?: string }): void {
  accessToken = tokens.accessToken;
  if (tokens.refreshToken) {
    refreshToken = tokens.refreshToken;
  }

  if (typeof window !== 'undefined') {
    setCookie(ACCESS_TOKEN_KEY, tokens.accessToken);
    if (tokens.refreshToken) {
      setCookie(REFRESH_TOKEN_KEY, tokens.refreshToken);
    }
  }
}

export function clearAuthTokens(): void {
  accessToken = null;
  refreshToken = null;
  if (typeof window !== 'undefined') {
    eraseCookie(ACCESS_TOKEN_KEY);
    eraseCookie(REFRESH_TOKEN_KEY);
  }
}
